import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeartbeat = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 19H16L18 16L22 22L24 19H31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 22.2C15.0971 25.0027 17.4396 27.613 20 30C22.5604 27.613 24.9029 25.0027 27 22.2",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 15.429C29.9923 13.987 29.4143 12.6066 28.3922 11.5894C27.3701 10.5722 25.987 10.0008 24.545 10C23.6457 10.0063 22.7616 10.2321 21.9695 10.6579C21.1774 11.0836 20.5013 11.6964 20 12.443C19.4987 11.6964 18.8226 11.0836 18.0305 10.6579C17.2384 10.2321 16.3543 10.0063 15.455 10C14.013 10.0008 12.6299 10.5722 11.6078 11.5894C10.5857 12.6066 10.0077 13.987 10 15.429",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgHeartbeat);
export default ForwardRef;
